import React from 'react'
import { Row, Col } from 'react-bootstrap'
import ReactTooltip from 'react-tooltip'
import './style.scss'

const Index = ({selectedType, setSelectedType}) => {
    return(
        <div className="select-channel-container">
            <div className={`single-selection-container ${selectedType === "email" ? "active":""}`}>
                <div onClick={() => setSelectedType("email")} className="inner-single-selection-container">
                    <Row>
                        <Col className="illustration-col my-auto">
                            <span className="illustration-icon"><i class="fad fa-envelope-open-text"></i></span>
                        </Col>
                        <Col className="details-col my-auto">
                            <h4 className="channel-title">E-post</h4>
                            <p className="channel-description">Gjør masseutsendelser av mail gjennom ditt foretrukne domene.</p>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className={`single-selection-container ${selectedType === "sms" ? "active":""}`}>
                <div onClick={() => setSelectedType("sms")} className="inner-single-selection-container">
                    <Row>
                        <Col className="illustration-col my-auto">
                            <span className="illustration-icon"><i class="fad fa-sms"></i></span>
                        </Col>
                        <Col className="details-col my-auto">
                            <h4 className="channel-title">SMS</h4>
                            <p className="channel-description">Gjør masseutsendelser gjennom SMS ved bruk av alfanumerisk nummer.</p>
                        </Col>
                    </Row>
                </div>
            </div>
            <ReactTooltip/>
        </div>
    )
}

export default Index